"use client";

import { motion } from "framer-motion";
import posthog from "posthog-js";
import { useEffect } from "react";

import { POSTHOG_EVENTS } from "~/core/constants/analytics";

import { SubscriptionPlan } from "../enums";
import { useSubscriptionCheckout } from "../hooks/useSubscriptionCheckout";

import SubscriptionAlert from "./Alert";
import SubscriptionButton from "./Plan/Button";
import SubscriptionCard from "./Plan/Card";
import SubscriptionFooter from "./Plan/Footer";
import SubscriptionHeader from "./Plan/Header";

const SubscriptionContent = () => {
  const { mutateAsync: checkoutSubscription, isPending } =
    useSubscriptionCheckout();

  useEffect(() => {
    posthog.capture(POSTHOG_EVENTS.BILLING.PAYWALL_SHOWN, {
      price: 200,
      plan: SubscriptionPlan.PRO,
    });
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="w-[580px] overflow-hidden rounded-lg bg-white-a12 shadow-lg cursor-pointer"
      onClick={() => !isPending && checkoutSubscription(SubscriptionPlan.PRO)}
    >
      <SubscriptionHeader />
      <div className="flex flex-col w-full gap-4 p-6">
        <SubscriptionAlert />
        <SubscriptionButton />
        <SubscriptionCard />
        <SubscriptionFooter />
      </div>
    </motion.div>
  );
};

export default SubscriptionContent;
